// extracted by mini-css-extract-plugin
export default {"container":"HeaderUpper_container__wppuP","place":"HeaderUpper_place__q1NSJ","workingHours":"HeaderUpper_workingHours__Ciq4D","contacts":"HeaderUpper_contacts__Vopv1"};